import { SubscribeBackInStockConfirmationSchema } from "@redotech/redo-agents-cards/support-agents/confirm-subscribe-to-back-in-stock";
import { ContentType } from "@redotech/redo-support-common/conversation";
import * as z from "zod";
import { literal } from "zod";
import {
  AutoGeneratedFieldsSchema,
  BaseToolCallMessageSchema,
} from "../message-parser-utils";
/**
 * This is the message type for when the ai wants to let the customer
 * subscribe to back in stock notifications.
 */
const SubscribeToBackInStockMessageSchema = BaseToolCallMessageSchema.extend({
  contentType: literal(ContentType.SUBSCRIBE_TO_BACK_IN_STOCK_NOTIFICATION_UI),
  structuredContent: SubscribeBackInStockConfirmationSchema.optional(),
});
export type SubscribeToBackInStockMessage = z.infer<
  typeof SubscribeToBackInStockMessageSchema
>;

export const SubscribeToBackInStockMessageDbParser =
  SubscribeToBackInStockMessageSchema.merge(AutoGeneratedFieldsSchema);
export type SubscribeToBackInStockMessageType = z.infer<
  typeof SubscribeToBackInStockMessageDbParser
>;
